import {Component, OnInit} from '@angular/core';
import {NotificationBannerService} from "./notification-banner.service";
import { HttpParams } from "@angular/common/http";
import {NotificationBanner} from "../../models/NotificationBanner";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  imports: [
    NgIf
  ],
  styleUrls: ['./notification-banner.component.scss']
})
export class NotificationBannerComponent implements OnInit {

  alert: NotificationBanner | null = null;

  constructor(private bannerService: NotificationBannerService) {

    let searchParams = new HttpParams();
    searchParams = searchParams.append('per_page', '1');
    searchParams = searchParams.append('is_active', '1');

    this.alert = {
      id: "1",
      text: "Talentview, Talentview Construction, and Talentview Aviation have now teamed up under one platform for students and graduates to search jobs, find courses and study options,<br />and connect with top employers in key industries. <a href='/news/New-Talentview-Launched'>Find out more</a>",
      mobile_text: "Check out our latest feature that enhances your experience.",
      is_active: true
    } as NotificationBanner;

    /*this.bannerService.showOnDesktop();
    this.bannerService.showOnMobile(15000);*/

    /*this.bannerService.get(searchParams).subscribe(alerts => {
      if(alerts.length) {
        this.alert = alerts[0];

        this.bannerService.showOnDesktop();
        this.bannerService.showOnMobile(15000);
      }
    });*/

    /*this.bannerService.previewAlert.subscribe(alert => {
      if(alert) {
        this.alert = alert;
      }
    });*/

  }

  ngOnInit() {
  }

  closeOnDesktop() {
    this.bannerService.hideOnDesktop();
  }

  closeOnMobile() {
    this.bannerService.hideOnMobile();
  }

}
